import { Route, Switch, Redirect, BrowserRouter as Router, useHistory } from 'react-router-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from '@material-ui/styles';
import { SnackbarProvider } from "notistack";
import i18n from 'i18n';
import store from 'store';
import {
    AppWrapper,
    Login,
    Home,
    Exams,
    Signup,
    VerifyEmail,
    ExamsView,
    CustomerView,
    SignupPaymentPage,
    ClientDashboard,
    AdminDashboard,
    PaymentSuccess,
    PaymentCancel,
    ForgotPassword,
    ResetPassword
} from "views";
import { LayoutExternal } from './components/layouts';
import theme from 'theme';
import 'App.css';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const AppRouter = () => {
    let history = useHistory();
    const HomePage = () => (<LayoutExternal key="homePage" footer={true} component={<Home />} />)
    const LoginPage = () => (<LayoutExternal key="loginPage" footer={true} component={<Login />} />)
    const ForgotPasswordPage = () => (<LayoutExternal key="forgotPasswordPage" footer={true} component={<ForgotPassword />} />)
    const ResetPasswordPage = () => (<LayoutExternal key="resetPasswordPage" footer={true} component={<ResetPassword />} />)
    const SignupPage = () => (<LayoutExternal key="signupPage" footer={true} component={<Signup />} />)
    const SignupClinicianPage = () => (<LayoutExternal key="signupClinicianPage" footer={true} component={<Signup isClinician={true} />} />)
    const SignupPatientPage = () => (<LayoutExternal key="signupPatientPage" footer={true} component={<Signup isPatient={true} />} />)
    const VerifyEmailPage = () => (<LayoutExternal key="verifyEmailPage" footer={true} component={<VerifyEmail />} />)
    const CustomerListPage = () => (<LayoutExternal key="customerPage" footer={true} component={<ExamsView />} />)
    const CustomerViewPage = () => (<LayoutExternal key="customerViewPage" footer={true} component={<CustomerView />} />)
    const ClientDashboardPage = () => (<LayoutExternal key="usersPage" footer={true} component={<ClientDashboard />} />)
    const AdminDashboardPage = () => (<LayoutExternal key="adminPage" footer={true} component={<AdminDashboard />} />)
    const ExamsPage = () => (<LayoutExternal key="examsPage" footer={true} component={<Exams />} />)
    const SignupPaymentPageWrapper = () => (<LayoutExternal key="signupPayemntPage" footer={true} component={<SignupPaymentPage />} />)
    const PaymentSuccessPage = () => (<LayoutExternal key="paymentSuccessPage" footer={true} component={<PaymentSuccess />} />)
    const PaymentCancelPage = () => (<LayoutExternal key="paymentCancelledPage" footer={true} component={<PaymentCancel />} />)

    return (
        <AppWrapper>
            <Router history={history}>
                <Switch>
                    <Route path="/home" component={HomePage} />
                    <Route path="/login" component={LoginPage} />
                    <Route path="/forgot-password" component={ForgotPasswordPage} />
                    <Route path="/reset-password" component={ResetPasswordPage} />
                    <Route path="/gallery" component={ExamsPage} />
                    <Route path="/signup" component={SignupPage} />
                    <Route path="/signup-clinician" component={SignupClinicianPage} />
                    <Route path="/signup-patient" component={SignupPatientPage} />
                    <Route path="/signup-payment" component={SignupPaymentPageWrapper} />
                    <Route path="/client-verify-email" component={VerifyEmailPage} />
                    <Route path="/client/:id/:examId" component={CustomerViewPage} />
                    <Route path="/clinician-dashboard" component={CustomerListPage} />
                    <Route path="/client-dashboard" component={ClientDashboardPage} />
                    <Route path="/admin-dashboard" component={AdminDashboardPage} />
                    <Route path="/sucess-stripe-payment" component={PaymentSuccessPage} />
                    <Route path="/cancel-stripe-payment" component={PaymentCancelPage} />
                    <Redirect to="/home" />
                </Switch>
            </Router>
        </AppWrapper>
    )
}

const App = () => {
    const snackbarProps = { anchorOrigin: { vertical: 'top', horizontal: 'right' }, autoHideDuration: 3000 };
    const persistor = persistStore(store);
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <IntlProvider locale="en" messages={i18n.en}>
                    <ThemeProvider theme={theme}>
                        <SnackbarProvider maxSnack={1} {...snackbarProps}>
                            <CssBaseline />
                            <AppRouter />
                        </SnackbarProvider>
                    </ThemeProvider>
                </IntlProvider>
            </PersistGate>
        </Provider>
    )
}

export default App;